import React from 'react';
import EventLocation from '../../elements/EventLocation/EventLocation';
import SandboxedContent from '../../SandboxedContent/SandboxedContent';

const EventInfoContent = props => {
    const {event} = props;

    return (
        <>
            <div className="content">
                <SandboxedContent content={event.settings.description} fitHeightToContents noInnerPadding />
            </div>
            <br />
            <EventLocation event={event} />
        </>
    );
};

export default EventInfoContent;
